<span class="text-success" *ngIf="value"><fa-icon icon="check"></fa-icon></span>
<span class="text-danger"  *ngIf="!value"><fa-icon icon="times"></fa-icon></span>
